import React, { useState, useMemo } from 'react';
import {
  Row,
  Button,
  Col,
  FormSelect,
  FormInput,
  InlineEditColumnProps,
  InlineEditTable,
  Widget,
  FormSubmitButton,
  FormatText,
  ColumnProps,
} from '@digital/ui';
import { OrcamentoPlanilha } from '@app/api/ordemInvestimento';
import { Card, Input, Table } from 'antd';

interface TipoPlanilhaProps {
  dataPlanilhas: OrcamentoPlanilha[];
  exportarPlanilhaAntiga(item: OrcamentoPlanilha): void;
}

export const initialState: OrcamentoPlanilha = {
  revisao: 0,
  numero: 0,
  dataAprovacao: '',
  nome: '',
  projetoId: '',
  id: '',
};

const TablePlanilha = (props: TipoPlanilhaProps) => {
  const { dataPlanilhas, exportarPlanilhaAntiga } = props;
  const [acronimoPlanilha, setAcronimoPlanilha] = useState<OrcamentoPlanilha>();

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'numberIndex',
        width: '2%',
      },
      {
        title: 'Revisão',
        dataIndex: 'revisao',
        width: '8%',
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '10%',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '10%',
      },
      {
        title: 'Data aprovação',
        dataIndex: 'dataAprovacao',
        width: '20%',
      },
      {
        title: 'Nome do arquivo',
        dataIndex: 'nome',
        width: '50%',
      },
      {
        title: 'Ações',
        render: (item: OrcamentoPlanilha) => (
          <>
            <Button
              onClick={() => handleClick(item)}
              icon="files-xls"
              style={{ width: 43, margin: 4, textAlign: 'center' }}
            />
          </>
        ),
      },
    ];
  };

  const handleClick = (item: OrcamentoPlanilha) => {
    if (item) {
      exportarPlanilhaAntiga(item);
    }
  };

  return (
    <>
      <Widget title="Planilhas" style={{ textAlign: 'center' }}>
        <Table
          className="removeScrollbar"
          rowKey="id"
          columns={customColumns()}
          dataSource={dataPlanilhas}
          pagination={false}
        />
      </Widget>
    </>
  );
};

export default TablePlanilha;
